import style from './App.module.css'
import { Input } from './components/Input/Input';
import { Button } from './components/Button/Button';
import { useEffect, useState } from 'react';
import { login, loginOAuth, getOffice, loginIntern } from './api/apiLogin';
import { Logo } from './components/Logo/Logo';
import {
  getOAuthErrorMessage,
  getOAuthParams,
  isOAuthAuthorizePage,
  redirectToOAuthCallback,
  saveOAuthTokens,
  validateOAuthParams,
} from './oauth';


function App() {
  const [loading, setLoading] = useState(false)
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [textError, setTextError] = useState('')
  const [textSuccess, setTextSuccess] = useState('')
  const [isOffice, setIsOffice] = useState(false)

  const isOAuth = isOAuthAuthorizePage()
  const oauthParams = isOAuth ? getOAuthParams() : null
  const oauthError = isOAuth ? validateOAuthParams(oauthParams) : null

  function auth() {
    if (!username || !password) return;
    if (isOAuth && oauthError) return;

    setTextError('')
    setTextSuccess('')
    setLoading(true)

    if (isOAuth) {
      loginOAuth(username, password, oauthParams).then(response => {
        setLoading(false)
        const data = response?.data
        if (!data) {
          setTextError('Ошибка авторизации. Попробуйте ещё раз.')
          return
        }
        if (data.error) {
          setTextError(getOAuthErrorMessage(data.error))
          return
        }
        if (data.status === 'no') {
          setTextError('Неверный логин или пароль.')
          return
        }
        if (data.code && data.redirect_uri) {
          setTextSuccess('Успешный вход.')
          redirectToOAuthCallback(data)
          return
        }
        setTextError('Ошибка авторизации. Попробуйте ещё раз.')
      })
      return
    }

    login(username, password).then(response => {
      setLoading(false)
      const { status, accessToken, refreshToken, expiresAt } = response.data
      if (status === 'ok') {
        saveOAuthTokens({ accessToken, refreshToken, expiresAt })
        setTextSuccess('Успешный вход.')
        document.location.href = `${document.location.origin}/new/sales/`
      } else {
        setTextError('Неверный логин или пароль.')
      }
    })
  }

  function authIntern() {
    setTextError('')
    setTextSuccess('')

    setLoading(true)
    loginIntern().then(response => {
      setLoading(false)
      const {status} = response.data
      if (status === 'ok') {
        setTextSuccess('Успешный вход.')
        document.location.href = `${document.location.origin}/new/sale/`
      } else {
        setTextError('Ошибка быстрой авторизации.')
      }
    })
  }

  useEffect(() => {
    if (isOAuth) {
      if (oauthError) setTextError(getOAuthErrorMessage(oauthError))
      return
    }
    getOffice().then(response => {
      setIsOffice(response.data?.data?.is_office || false)
    })
  }, [isOAuth, oauthError])

  const showForm = !isOAuth || !oauthError

  return (
    <div className={style.back}>
      <Logo />
      <div className={style.container}>
        {
          (textError || textSuccess) &&
          <div className={textError ? style.error : style.success}>
            {textError || textSuccess}
          </div>
        }

        {showForm && (
          <>
            <div className={style.inputs}>
              <Input label='Логин'
                value={username}
                onInput={(e) => setUsername(e.target.value)}
                onKeyDown={auth}
              />
              <Input
                value={password}
                onInput={(e) => setPassword(e.target.value)}
                onKeyDown={auth}
                label='Пароль'
                password
              />
            </div>

            <div className={style.buttons}>
              {
                !isOAuth && isOffice &&
                <Button
                  label='Я Стажёр'
                  white
                  onClick={authIntern}
                />
              }
              <Button
                label='Войти'
                onClick={auth}
                disabled={!username || !password || loading}
                loading={loading}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default App;
